export default {
  name: 'jsonata',
  title: 'Jsonata',
  owner: 'System',
  solution: '',
  tags: ['datasources', 'jsonata'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    datasources: {
      now: {
        type: 'jsonata',
        options: {
          expression: '$now()',
        },
        refetchInterval: 5000,
      },
    },
    data: {
      now: {
        data: 'this will be overridden',
      },
    },
    view: [['div', {}, '/${ data.now.data }']],
  },
};
